module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-hr-3-0806c7064d94acc449d6712491b879a1.png";